import { DESKTOP_FILTERS_CONTAINER_ID } from '@/components/Filters/DesktopFilters/DesktopFilters.constants';

export function adjustScrollPosition(
  accordionRef: React.RefObject<HTMLDivElement>
) {
  if (typeof document === 'undefined') return;

  const desktopFiltersContainer = document.getElementById(
    DESKTOP_FILTERS_CONTAINER_ID
  );
  const { bottom: accordionBottom = 0 } =
    accordionRef.current?.getBoundingClientRect() ?? {};
  const { bottom: containerBottom = 0 } =
    desktopFiltersContainer?.getBoundingClientRect() ?? {};

  if (desktopFiltersContainer && accordionBottom > containerBottom) {
    desktopFiltersContainer.scrollBy({
      top: accordionBottom - containerBottom,
      behavior: 'smooth',
    });
  }
}
